import { Button, ButtonsGroup, Modal, SectionMessage, Space, Text, useModal } from '@billy/design-system'
import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { WarningModalRequiredProps } from '../../../../hooks/useWarningModals'
import * as Styled from './styles'
import { getTranslations } from './utils/getTranslations'

type VATConfirmationModalProps = WarningModalRequiredProps

export const VATConfirmationModal = ({ onOk, id }: VATConfirmationModalProps): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { close } = useModal(id)

  const currentIsVatExempted = organization ? organization.isVatExempted : false
  const isCountryFrance = organization?.countryId === 'FR'
  const translations = useMemo(() => getTranslations(currentIsVatExempted, t), [currentIsVatExempted, t])

  const handleSave = useCallback(() => {
    onOk?.(id)
    close()
  }, [close, id, onOk])

  const handleCancel = useCallback(() => {
    close()
  }, [close])

  return (
    <Modal closable id={id} size="s">
      <Modal.Header title={translations.title}></Modal.Header>
      <Modal.Body>
        <Text weight="bold">{translations.subtitle}</Text>
        <Space />
        <Text>{translations.body}</Text>
        {isCountryFrance && (
          <>
            <Space />
            <Text>{translations.frenchLegalListTitle}</Text>
            <Styled.BulletPointList>
              <Styled.BulletPoint>{translations.frenchLegalListPoint1}</Styled.BulletPoint>
              <Styled.BulletPoint>{translations.frenchLegalListPoint2}</Styled.BulletPoint>
              <Styled.BulletPoint>{translations.frenchLegalListPoint3}</Styled.BulletPoint>
            </Styled.BulletPointList>
            <Space />
            <SectionMessage closable={false}>{translations.alert}</SectionMessage>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonsGroup>
          <Button variant="text" onClick={handleCancel}>
            {t('settings.organization.organization_info.vat_confirmation_modal.disapprove')}
          </Button>
          <Button onClick={handleSave}>{translations.cta}</Button>
        </ButtonsGroup>
      </Modal.Footer>
    </Modal>
  )
}
